import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';

import Styled from 'styled';
import { RetryDialog } from 'lib/alerts/dialog';
import withDialog from 'lib/alerts/with-dialog';
import FadingCircleView from 'lib/loaders/spinkit/fading-circle-view';
import ButtonView from '../button-view';

import defaultStyles from './action-button-view.scss';
import fadingCircleStyles from './fading-circle-view.scss';

@withDialog
@observer
class ActionButtonView extends React.Component {
    @observable loading = false;

    onClick = event => {
        this.loading = true;
        this.props
            .onClick(event)
            .then()
            .catch(err => {
                this.props.showDialog(
                    new RetryDialog({
                        message: err.message,
                        retry: this.handleOnClick,
                    })
                );
            })
            .finally(() => {
                this.loading = false;
            });
        return null;
    };

    render() {
        const { disabled, children, icon, showDialog, styles, ...rest } = this.props;

        return (
            <ButtonView
                {...rest}
                styles={styles}
                icon={this.loading ? <FadingCircleView styles={fadingCircleStyles} /> : icon}
                onClick={this.onClick}
                disabled={this.loading || disabled}
            >
                {children}
            </ButtonView>
        );
    }
}

export default Styled(defaultStyles)(ActionButtonView);
